import { render, staticRenderFns } from "./OtherCompanyConstructionListPage.vue?vue&type=template&id=178bcb6b&"
import script from "./OtherCompanyConstructionListPage.vue?vue&type=script&lang=ts&"
export * from "./OtherCompanyConstructionListPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports